import React, { ReactNode, createContext, useState } from 'react';

interface Props {
    children?:ReactNode
}

export const SearchContext = createContext({
    searchTerms: [] as Array<string>,
    addSearchTerm: (term: string) => {},
    addSearchTerms: (terms: Array<string>) => {},
    removeSearchTerm: (term: string) => {}
});

const SearchContextProvider : React.FC<Props> = ({children}) => {
    const [searchTerms, setSearchTerms] = useState([] as Array<string>);

    console.log("SEARCH", searchTerms);

    const addSearchTerm = (term: string):void => {
        if(!searchTerms.includes(term)) {
            setSearchTerms([...searchTerms, term]);
        }
    }

    const addSearchTerms = (terms: Array<string>) => {
        setSearchTerms(terms);
    }

    const removeSearchTerm = (term: string) => {
        setSearchTerms(searchTerms.filter(st => st !== term));
    }

    return <SearchContext.Provider value={{searchTerms, addSearchTerm, addSearchTerms, removeSearchTerm}}>{children}</SearchContext.Provider>
}

export default SearchContextProvider;